/**
 * HomeRouter — root path dispatcher.
 *
 * Reads two signals to swap the homepage per site:
 *   1. Domain — indianfamilytree.com auto-routes to its own home page
 *   2. `?site=<slug>` query — preview any child home from inside the parent
 *
 * Use cases:
 *   /                        → default Home (or the domain-matched sibling home)
 *   /?site=kerala            → KeralaHome
 *   /?site=indianfamilytree  → IndianFamilyTreeHome
 *   /?site=socialpulse       → default Home (explicit opt-in)
 */
import { useSearchParams } from "react-router-dom";
import Home from "@/pages/Home";
import BlogHome from "@/pages/blog/BlogHome";
import KeralaHome from "@/pages/KeralaHome";
import KeralaTravelsHome from "@/pages/KeralaTravelsHome";
import IndianFamilyTreeHome from "@/pages/IndianFamilyTreeHome";
import MyFamilyTreeCareHome from "@/pages/MyFamilyTreeCareHome";
import FoodPulseHome from "@/pages/FoodPulseHome";
import SellnBuyHome from "@/pages/SellnBuyHome";
import SocialCapitalHome from "@/pages/SocialCapitalHome";
import WorldPulseHome from "@/pages/WorldPulseHome";
import WorldPulseLanding from "@/pages/WorldPulseLanding";
import { resolveSiteSlug } from "@/config/siteConfig";

const SITE_ROUTES = {
  kerala:            KeralaHome,
  keralatravels:     KeralaTravelsHome,
  indianfamilytree:  IndianFamilyTreeHome,
  myfamilytreecare:  MyFamilyTreeCareHome,
  foodpulse:         FoodPulseHome,
  sellnbuy:          SellnBuyHome,
  socialcapital:     SocialCapitalHome,
  worldpulse:        WorldPulseLanding,
  indias:            WorldPulseHome,
  usapulse:          WorldPulseHome,
  // BlogsPulse — SocialPulse.blog editorial landing.
  blogspulse:        BlogHome,
};

export default function HomeRouter() {
  const [params] = useSearchParams();
  const queryParam = (params.get("site") || "").toLowerCase();
  // Query param wins for previewing inside the parent. Otherwise fall
  // through to hostname-based resolution so indianfamilytree.com just
  // works on its apex domain.
  const site = queryParam || resolveSiteSlug();
  const Component = SITE_ROUTES[site] || Home;
  return <Component />;
}
